import loadable from '@loadable/component';

export const AnimatedBFImage = loadable(() => import('./bf-animated-image'));
